import React, { createContext, useContext, useEffect, useState } from "react";

const PopupContext = createContext(null);

export function PopProvider({ children }) {
  const [state, setState] = useState({
    open: false,
    type:null,
    success:null,
    message: "",
    resolve: null,
  });

  useEffect(() => {
    if (state.open && state.type === "flash") {
      const timer = setTimeout(() => {
        state.resolve?.(true); // optional, in case caller awaits
        setState((prev) => ({ ...prev, open: false }));
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [state.open, state.type])

  const popUp = (message, type = 'alert', success = true) => {
    return new Promise((resolve) => {
      setState({
        open: true,
        type,
        success,
        message,
        resolve,
      });
    });
  };

  const handleConfirm = () => {
    state.resolve(true);
    setState({ ...state, open: false });
  };

  const handleCancel = () => {
    state.resolve(false);
    setState({ ...state, open: false });
  };

  return (
    <PopupContext.Provider value={popUp}>
      {children}

      {state.open && (
        <div className={`boggler-modal ${state.type} ${state.success ? 'g' : 'r'}`}>
          <div className="container">
            <p>{state.message}</p>
              <div className="actions">
                {state.type === 'confirm' && (<button className="btn sm red" onClick={handleCancel}>Cancel</button>)}
                {state.type !== 'flash' && <button className="btn sm" onClick={handleConfirm}>{state.type === 'confirm' ? 'Confirm' : 'Okay'}</button>}
              </div>
          </div>
        </div>
      )}
    </PopupContext.Provider>
  );
}
/**
 * Creates a confirm or alert modal
 *
 * @param {String | string} message - Message to display
 * @param {string} type - ('confirm' | 'prompt' | 'flash')
 * @param {bool} success - Used for flash
 * @returns {boolean}
 */
export function usePopup() {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error("usePopup must be used within a PopupProvider");
  }
  return context;
}
